/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FormFieldCard_formField$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormFieldBoard_form$ref: FragmentReference;
declare export opaque type FormFieldBoard_form$fragmentType: FormFieldBoard_form$ref;
export type FormFieldBoard_form = {|
  +id: string,
  +fields: $ReadOnlyArray<{|
    +id: string,
    +displayOrder: number,
    +$fragmentRefs: FormFieldCard_formField$ref,
  |}>,
  +$refType: FormFieldBoard_form$ref,
|};
export type FormFieldBoard_form$data = FormFieldBoard_form;
export type FormFieldBoard_form$key = {
  +$data?: FormFieldBoard_form$data,
  +$fragmentRefs: FormFieldBoard_form$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "FormFieldBoard_form",
  "type": "Form",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "fields",
      "storageKey": null,
      "args": null,
      "concreteType": "FormField",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayOrder",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "FormFieldCard_formField",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '046d6fe0399d94f667381c9dd0bd07b2';
module.exports = node;
